import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import RefreshIcon from '@material-ui/icons/Refresh';

const API = 'https://api.openweathermap.org/data/2.5/weather?zip=';
const DEFAULT_QUERY = ',us&units=imperial';
const APPID = '&APPID=6808525dc3187c0a95e546bcfa8c3ac4';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 160,
  },
  input: {
    color: "white",
    fontStyle: "underline",
  },
  underline: {
    '&:after': {
      borderBottom: '2px solid #FFFFFF',
    },
    '&$focused:after': {
      borderBottomColor: '#FFFFFF',
    },
    '&$error:after': {
      borderBottomColor: '#FFFFFF',
    },
    '&:before': {
      borderBottom: '1px solid #FFFFFF',
    },
    '&:hover:not($disabled):not($focused):not($error):before': {
      borderBottom: '2px solid #FFFFFF',
    },
    '&$disabled:before': {
      borderBottom: '1px dotted #FFFFFF',
    },
  },
  appBar: {
    backgroundColor: "#4289af",
    boxShadow: "none",
    mozBoxShadow: "none",
    webkitBoxShadow: "none",
  },
  weatherPaper: {
    maxWidth: 520,
    backgroundColor: "#f1f1f1",
  },
});

class Weather extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zip: '32807',
      weatherData: [],
      isLoading: false,
      error: null,
      weatherTempColor: '#f1f1f1',
      weatherSVG: '../images/weather-icons/day.svg',
      weatherSVGHover: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setTemp(rawTemp) {
    var temp = Math.ceil(rawTemp);
    return temp;
  }

  handleChange(event) {
    this.setState({ zip: event.target.value });
  }

  handleSubmit(event) {
    if (this.state.zip.length === 5) {
      this.getMeSomeWeather();
    }
    else {
      alert("Zip code must be 5 digits!");
    }
    event.preventDefault();
  }

  getMeSomeWeather() {
    this.setState({ isLoading: true });
    this.setState({ weatherTempColor: '#f1f1f1' });

    fetch(API + this.state.zip + DEFAULT_QUERY + APPID)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Something unexpected has happened!');
        }
      })
      .then(data => {
        var tempColor = '#f1f1f1';
        var temperature = 80;
        var weatherSVG = 'day.svg';

        if (data.main.temp) {
          temperature = Math.ceil(data.main.temp);

          if (temperature >= 80) {
            tempColor = '#f8ca24';
          }
          else if (temperature < 80 && temperature >= 70) {
            tempColor = '#f2f824';
          }
          else if (temperature < 70 && temperature >= 50) {
            tempColor = '#24e8f8';
          }
          else if (temperature < 50) {
            tempColor = '#5bb3fb';
          }
        }

        if (data.weather[0].icon) {
          var icon = data.weather[0].icon;
          var weatherSVGHover = data.weather[0].description;
          weatherSVG = "unknown.svg";

          if (icon === '01d') {
            weatherSVG = 'day.svg';
          }
          else if (icon === '01n') {
            weatherSVG = 'night.svg';
          }
          else if (icon === '02d') {
            weatherSVG = 'cloudy-day-3.svg';
          }
          else if (icon === '02n') {
            weatherSVG = 'cloudy-night-3.svg';
          }
          else if ((icon === '03d') || (icon === '04d') || (icon === '03n') || (icon === '04n')) {
            weatherSVG = 'cloudy.svg';
          }
          else if (icon === '09d') {
            weatherSVG = 'rainy-1.svg';
          }
          else if (icon === '09n') {
            weatherSVG = 'rainy-4.svg';
          }
          else if ((icon === '10d') || (icon === '10n')) {
            weatherSVG = 'rainy-7.svg';
          }
          else if ((icon === '11d') || (icon === '11n')) {
            weatherSVG = 'thunder.svg';
          }
          else if ((icon === '13d') || (icon === '13n')) {
            weatherSVG = 'snowy-6.svg';
          }

          weatherSVG = require('../images/weather-icons/' + weatherSVG);
        }
        this.setState({ weatherData: data, isLoading: false, weatherTempColor: tempColor, weatherSVG: weatherSVG, weatherSVGHover: weatherSVGHover });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.getMeSomeWeather();
  }

  render() {
    const { weatherData, isLoading, error } = this.state;
    const { classes } = this.props;

    // Check the weatherData object to make sure it has data before proceeding...
    if (weatherData.length === 0) {
      return null;
    }

    if (error) {
      return (
        <div>
          <h4>Weather</h4>
          <p>{error.message}</p>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div>
          <h4>Weather</h4>
          <p>...Loading...</p>
        </div>
      );
    }

    return (
      <div>
        <h4>Weather</h4>
        <p>Simple application of the Open Weather Map API ( free ) to display some basic weather information based on a users zip code in the United States.</p>
        <br />
        <Paper className={classes.weatherPaper} elevation={1}>
          <AppBar position="static" className={classes.appBar}>
            <div className="weather-header-cont">
              <div className="weather-header-left">
                The Weather
              </div>
              <div className="weather-header-right">
                <form onSubmit={this.handleSubmit}>
                  <TextField
                    id="zipCode"
                    label="Zip Code ( 5 Digit )"
                    className={classes.textField}
                    value={this.state.zip}
                    onChange={this.handleChange}
                    margin="normal"
                    required
                    maxLength="5"
                    minLength="5"
                    InputProps={{
                      classes:{ input: classes.input, underline: classes.underline }
                    }}
                    InputLabelProps={{
                      className: classes.input
                    }}
                  />
                  <IconButton className={classes.button} aria-label="Reload" color="inherit" onClick={this.handleSubmit}>
                    <RefreshIcon />
                  </IconButton>
                </form>
              </div>
            </div>
          </AppBar>
          <div className="weather-cont">
            <div style={{ backgroundColor: this.state.weatherTempColor }} className="weather-left">
              {Math.ceil(weatherData.main.temp)}&deg;
            </div>
            <div className="weather-right">
              <img src={this.state.weatherSVG} width="128" height="128" title={this.state.weatherSVGHover} alt={this.state.weatherSVGHover} />
            </div>
          </div>
        </Paper>
        <p>&nbsp;</p>
      </div >
    );
  }
}

Weather.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Weather);



// WEBPACK FOOTER //
// ./src/components/Weather.js